/**
 *  @class
 *  @function ArticleNavigationLocate
 */
if (!customElements.get('article-navigation-locate')) {
    class ArticleNavigationLocate extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        window.setTimeout(() => {
          this.article_element = document.getElementById('main-article');
          this.title_element = document.getElementById('post-title-wrapper');
          this.blogNavTag=document.getElementById('blogNavTag');
          this.blogNavTagBox=document.getElementById('blogNavTagBox');
          this.articleNavigationLocate=document.querySelector('article-navigation-locate');
          // append a scroll event listener to the window object
          window.addEventListener('scroll', this.setStickyClass.bind(this));
          window.dispatchEvent(new Event('scroll'));
          let newNode = document.createElement('div');
            newNode.innerHTML = document.getElementById('fixedLeft').innerHTML;
          this.blogNavTag.appendChild(newNode);
          this.blogNavTag.style.width=document.getElementById('blogNavTagBox').offsetWidth-30+'px';
          this.isArticleNavigation=customElements.get('article-navigation')
          if(this.isArticleNavigation){
            this.articleNavigation=document.querySelector('article-navigation');
            this.articleNavigationTop=this.articleNavigation.offsetTop;
            this.articleNavigation.style.top=this.articleNavigationTop+'px';
          }
          if(window.innerWidth<768){
            this.articleNavigationLocate.style.display="none";
            this.blogNavTagBox.style.display="none";
            this.articleNavigation.style.top=this.articleNavigationTop+this.articleNavigationLocate.offsetHeight+'px';
          }else{
        // convert pixels to percentage
            document.querySelector('article-navigation-locate').style.display="none";
          }
        });
      }
      setStickyClass() {
        let title_offset = this.title_element.getBoundingClientRect().top + window.scrollY + this.title_element.offsetHeight,
        article_offset = this.article_element.getBoundingClientRect().top + window.scrollY + this.article_element.offsetHeight;
        if (window.scrollY > title_offset) {
            if(window.innerWidth>768){
              this.blogNavTag.style.width=document.getElementById('blogNavTagBox').offsetWidth-30+'px';
              this.blogNavTag.classList.add('fixedNav');
            }else{
              this.articleNavigation.style.top=this.blogNavTag.offsetHeight+document.querySelector('article-navigation-locate').offsetHeight+45+'px';
            }
        }else{
          if(window.innerWidth>768){this.blogNavTag.classList.remove('fixedNav');}
          this.articleNavigation.style.top=this.articleNavigationTop+document.querySelector('article-navigation-locate').offsetHeight+'px';
        }
        if (document.querySelector('.announcement-bar')&&window.scrollY<document.querySelector('.announcement-bar').offsetHeight) {
          this.blogNavTag.classList.remove('fixedNav');
          document.querySelector('article-navigation-locate').classList.remove('active');
        }
        if (window.innerWidth>768&&(window.scrollY > article_offset- document.getElementById('blogNavTag').offsetHeight-450)) {
          this.blogNavTag.classList.remove('fixedNav');
        }
        if(window.innerWidth<768){
          if(window.scrollY<10){
            this.articleNavigationLocate.style.display="none";
          }else{
            this.articleNavigationLocate.style.display="block";
          }
        }
      }
    }
    customElements.define('article-navigation-locate', ArticleNavigationLocate);
  }
  function toggleNavLocate(){
    if(customElements.get('article-navigation')){
      this.articleNavigation=document.querySelector('article-navigation');
      this.articleNavigationTop=this.articleNavigation.offsetTop;
    }
    this.blogNavTag=document.getElementById('blogNavTag');
    this.blogNavTagBox=document.getElementById('blogNavTagBox');
    let ElTag=document.querySelector('article-navigation-locate');
    this.blogNavTag.style.width='100%';
    console.log("==this.articleNavigation.style.top",this.articleNavigation.style.top)
    if(ElTag.classList.contains("active")){
      ElTag.classList.remove('active');
      this.blogNavTagBox.style.display="none";
     // this.articleNavigation.style.top=document.querySelector('article-navigation-locate').offsetHeight+'px';
      this.blogNavTag.classList.remove('fixedNav');
    }else{
      ElTag.classList.add('active');
      this.blogNavTagBox.style.display="block";
      this.blogNavTag.classList.add('fixedNav');
     // this.articleNavigation.style.top=this.blogNavTag.offsetHeight+document.querySelector('article-navigation-locate').offsetHeight+'px';
    
    }
  }